import { useCallback, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function useSelectedLessonRoute() {
	const location = useLocation();
	const navigate = useNavigate();
	const { lessonId } = useParams<{ lessonId?: string }>();
	const selectedLessonId = lessonId ?? null;
	const selectedLessonIdRef = useRef(selectedLessonId);
	selectedLessonIdRef.current = selectedLessonId;

	const setSelectedLessonId = useCallback((nextLessonId: string | null) => {
		const pathname = nextLessonId ? `/admin/grafik/${nextLessonId}` : '/admin/grafik';
		navigate({ pathname, search: location.search }, { replace: true });
	}, [location.search, navigate]);

	const toggleSelectedLessonId = useCallback((nextLessonId: string) => {
		setSelectedLessonId(nextLessonId === selectedLessonIdRef.current ? null : nextLessonId);
	}, [setSelectedLessonId]);

	return { selectedLessonId, setSelectedLessonId, toggleSelectedLessonId };
}
